import { BillingContactInfo } from '@backoffice/fast-payments-client-js-sdk';
import { TransactionContact } from '../models';

export const mapBillingToBGv3 = (billingInfo: TransactionContact): BillingContactInfo => {
  let returnValue: BillingContactInfo = {
    name: {
      first: billingInfo.fname,
      last: billingInfo.lname,
    },
    address: {
      address1: billingInfo.addr1, // Optional except for ECHECK
      city: billingInfo.city, // Optional except for ECHECK
      state: billingInfo.state, // Optional except for ECHECK
      country: 'US',
      zip: billingInfo.zip,
    },
    contactInfo: {
      email: billingInfo.email, // Optional except for ECHECK
    },
  };

  if (billingInfo.addr2) {
    returnValue.address.address2 = billingInfo.addr2;
  }
  if (billingInfo.mname) {
    returnValue.name.middle = billingInfo.mname;
  }

  return returnValue;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/mappers/billingToBGv3.ts